export default __webpack_public_path__ + "static/media/deliveryMan.612bd0f7.svg";